import { render, staticRenderFns } from "./UnbindStaff.vue?vue&type=template&id=1098afc8&"
import script from "./UnbindStaff.vue?vue&type=script&lang=js&"
export * from "./UnbindStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports